export default __webpack_public_path__ + "static/media/goshen54.da5639e5.JPG";